import { FC } from 'react';

import { IcPlay16Icon } from '@gem/icons';
import { IGraphicSize } from '@gem/models/commonModel';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import { ImagePreview } from 'APP/components/ImagePreview/ImagePreview';
import { MINIATURE_PREVIEW_MAX_SIZE } from 'APP/constants/messages';

import styles from './LayoutImagePreview.styles.m.css';

interface ILayoutImagePreviewProps {
  imageUrl: string;
  graphicSize?: IGraphicSize;
  isVideo: boolean;
}

export const LayoutImagePreview: FC<ILayoutImagePreviewProps> = (props) => {
  const { imageUrl, graphicSize, isVideo } = props;
  const imageSize = {
    width: graphicSize?.width || MINIATURE_PREVIEW_MAX_SIZE.width,
    height: graphicSize?.height || MINIATURE_PREVIEW_MAX_SIZE.height,
  };

  return (
    <ImagePreview
      className={styles.container}
      imageClassName={styles.image}
      url={imageUrl}
      graphicSize={imageSize}
      maxWidth={MINIATURE_PREVIEW_MAX_SIZE.width}
      maxHeight={MINIATURE_PREVIEW_MAX_SIZE.height}
      needCropImage
    >
      {isVideo && (
        <div className={styles.videoIconContainer}>
          <IconView
            className={styles.video}
            Icon={IcPlay16Icon}
            size={IconViewSizes.Small}
          />
        </div>
      )}
    </ImagePreview>
  );
};
